<template>
  <div>
    <title-bar :title-stack="['Device', this.$route.params.id]" />
    <section class="section is-main-section">
      <div class="columns">
        <div class="column is-6">
          <card-component title="Logs" icon="view-agenda">
            <device-log :device="this.$route.params.id"></device-log>
          </card-component>
        </div>
        <div class="column"> <!-- style="width: inherit; position: fixed;" -->
          <card-component style="height: 100%;" title="Map" icon="map">
            <Map :device="this.$route.params.id" :timeRange="timeRange"></Map>
          </card-component>
        </div>
      </div>

      <card-component title="Devices" icon="chart-timeline-variant">
        <plot v-bind:timeRange="timeRange" v-on:update:timeRange="updateRange" title="Accelerations" yLabel='Acceleration [m/s^2]' :traces="[this.$route.params.id+'/adxl357_x', this.$route.params.id+'/adxl357_y', this.$route.params.id+'/adxl357_z']" :traceNames="['x', 'y', 'z']"></plot>
        <plot v-bind:timeRange="timeRange" v-on:update:timeRange="updateRange" title="Accelerations" yLabel='Acceleration [m/s^2]' :traces="[this.$route.params.id+'/adxl375_x', this.$route.params.id+'/adxl375_y', this.$route.params.id+'/adxl375_z']" :traceNames="['x', 'y', 'z']"></plot>
        <plot v-bind:timeRange="timeRange" v-on:update:timeRange="updateRange" title="Variance" yLabel='Variance/Energy over 5s [m^2/s^4]' :traces="[this.$route.params.id+'/power_x', this.$route.params.id+'/power_y', this.$route.params.id+'/power_z']" :traceNames="['x', 'y', 'z']"></plot>
        <plot v-bind:timeRange="timeRange" v-on:update:timeRange="updateRange" title="Temperature and Humidity" yLabel='Temperature [°C], Humidity [RH]' :traces="[this.$route.params.id+'/temphumi_x', this.$route.params.id+'/temphumi_y']" :traceNames="['temp', 'humidity']"></plot>
        <log-plot v-bind:timeRange="timeRange" title="Accelerations" yLabel='PSD' :traces="[this.$route.params.id+'/x', this.$route.params.id+'/y', this.$route.params.id+'/z']" :traceNames="['x', 'y', 'z']"></log-plot>
      </card-component>
    </section>
  </div>
</template>
<script>
import Plot from '@/components/TN-Plot'
import LogPlot from '@/components/TN-LogPlot'
import TitleBar from '@/components/TitleBar'
import DeviceLog from '@/components/TN-DeviceLogs'
import CardComponent from '@/components/CardComponent'
import Map from '@/components/TN-Map'

function yesterday () {
  var d = new Date()
  d.setDate(d.getDate() - 1)
  return d
}

export default {
  name: 'device',
  components: {
    Plot,
    LogPlot,
    TitleBar,
    DeviceLog,
    CardComponent,
    Map
  },
  data () {
    return {
      id: null,
      timeRange: [yesterday(), new Date()],
      options: {
        width: 2560,
        height: 600,
        scales: {
          x: {
            time: false
          }
        },
        series: [
          {},
          {
            // show: false,
            stroke: 'red',
            fill: 'rgba(255,0,0,0.1)',
            spanGaps: false
          },
          {
            // show: false,
            stroke: 'green',
            fill: 'rgba(0,255,0,0.1)',
            spanGaps: false
          },
          {
            // show: false,
            stroke: 'blue',
            fill: 'rgba(0,0,255,0.1)',
            spanGaps: false
          }
        ]
      },
      data: [
        [1546300800, 1546387200], // x-values (timestamps)
        [35, 71], // y-values (series 1)
        [90, 15] // y-values (series 2)
      ]
    }
  },
  methods: {
    updateRange: function (val) {
      // console.log('updated range from event', val)
      this.timeRange = val
    }
  }
}

</script>
